/**
 * Global Toast Provider
 * 
 * Uses sonner for lightweight, dark-mode-native notifications.
 * Import `toast` from 'sonner' in any component to trigger toasts.
 */

import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      theme="dark"
      richColors
      toastOptions={{
        style: {
          background: 'rgba(30, 30, 46, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(20px)',
          color: 'rgba(255, 255, 255, 0.9)',
        },
      }}
    />
  );
}
